import { txtAnimation } from 'components/Home/BannerItems';
import { BBBright, GRAY10, GRAY50, BodyTextL, H5 } from 'global-styles';
import { useInView } from 'react-intersection-observer';
import styled, { css } from 'styled-components';
import { ProductCommonTitleEn, ProductCommonTitleKR } from './ProductCommons';
import { LocaleObj } from './ProductFeatures';

interface Props {
  pName: string;
  provide: { name: 'SDK' | 'Silicon IP' | 'UI Service'; text: LocaleObj }[];
  locale: string;
}

const ProductProvide = ({ pName, provide, locale }: Props) => {
  const [targetRef, isVisible] = useInView({ fallbackInView: true });
  if (pName.toLowerCase().includes('avif')) return null;

  if (provide.length === 0 && !pName.toLowerCase().includes('avif'))
    return (
      <ProductProvideContainer
        ref={targetRef}
        isVisible={isVisible}
        style={{ padding: '10px 0' }}
      />
    );

  return (
    <ProductProvideContainer ref={targetRef} isVisible={isVisible}>
      <div className="feat-title-wrapper">
        {locale === 'en' ? (
          <ProductCommonTitleEn>
            How we deliver the product
          </ProductCommonTitleEn>
        ) : (
          <ProductCommonTitleKR>제품 제공방식</ProductCommonTitleKR>
        )}
      </div>

      <div className="provide-box-wrapper">
        {provide.map(p => (
          <div className="provide-box" key={p.name}>
            <H5 className="provide-name">
              <span className="dot" />
              <span>{p.name}</span>
            </H5>
            <BodyTextL>{p.text[locale]}</BodyTextL>
          </div>
        ))}
      </div>
    </ProductProvideContainer>
  );
};

export default ProductProvide;

const ProductProvideContainer = styled.article<{
  isVisible: boolean;
}>`
  padding: 96px 0;
  overflow: hidden;
  .provide-box-wrapper {
    margin: 32px 0 32px;
    display: flex;
    gap: 56px;
    flex-wrap: wrap;
  }
  .provide-box {
    flex-shrink: 0;
    width: calc(50% - 28px);
    color: ${GRAY50};
  }
  .provide-name {
    color: ${GRAY10};
    margin-bottom: 8px;
    display: flex;
    align-items: center;
  }
  .dot {
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: ${BBBright};
    display: inline-block;
    margin-right: 8px;
  }
  ${({ isVisible }) =>
    isVisible &&
    css`
      .feat-title-wrapper {
        animation: ${txtAnimation} 1s cubic-bezier(0.4, 0, 0.2, 1) backwards;
        opacity: 1;
      }
      .provide-box-wrapper {
        animation: ${txtAnimation} 1s 0.3s cubic-bezier(0.4, 0, 0.2, 1)
          backwards;
        opacity: 1;
      }
    `};
  @media screen and (max-width: 904px) {
    padding: 56px 0;
    .provide-box-wrapper {
      gap: 0;
    }
    .provide-box {
      width: 100%;
    }
    .provide-box + .provide-box {
      margin-top: 32px;
    }
  }
  @media screen and (max-width: 599px) {
    padding: 32px 0;
  }
`;
